export default __webpack_public_path__ + "static/about-hero-bg-6a5cae16d782171a233c3e662dcf9945.png";